var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rack"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card-headerfrm filter_main row",
    staticStyle: {
      "margin": "1px 16px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-actions col-md-6 "
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('a', {
    attrs: {
      "title": "Go To Manifest Listing"
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    attrs: {
      "style": "font-size:18px; cursor:pointer; "
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.manifestid')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifest))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.manifestDate')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.manifest_date)) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.courier')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifestDetails.couriercompany) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('manifesthandover.totalAwb')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifestDetails.awbcount) + " ")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "page"
  }, [_c('table', {
    staticClass: "datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.srNo')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('ShippingDetails.awbNo')) + "#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Return Type")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.awbdetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(_vm.calculateSerialNumber(index)) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.awbno) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(data.returntype))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.awbdetails.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "width": "98%"
    }
  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v("Person Name")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifestDetails.deliveredby) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v("Contact No")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("  " + _vm._s(_vm.manifestDetails.deliverycontact) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v("Taken By")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(" " + _vm._s(_vm.manifestDetails.closedby))])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-bottom": "4px"
    }
  }, [_c('h6', [_vm._v("Returns Manifest")])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61990185", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61990185","hasScoped":true}!./src/views/components/returnsmanifestlist/viewreturnsmanifest/viewreturnsmanifest.component.html
// module id = 2187
// module chunks = 0